import styled from "styled-components";

export const FormValidationText = styled.span`
  color: red;
  display: block;
  font-size: 9px;
  margin-top: -10px;
`;
